<script>
export default {
    name: "FileInput",
    model: {
        prop: 'file',
        event: 'files-selected',
    },
    props: {
        file: {
            type: File,
            default: function () {
                return null;
            }
        },
        httpRequest: Function,
        customClass: String,
        fullWidth: {
          type: Boolean,
          default: true
        },
    },
    data() {
        return {
            fileList: [],
        }
    },
    methods: {
        validFile(file) {
            if (file.type === 'application/pdf' || file.type.startsWith("image/")) {
                return true;
            }
            this.$message.error("Файл не підтримується, тільки pdf чи зображення");

            return false
        },
        removeFile() {
            this.fileList = [];
            this.$emit("files-selected", null);
            this.$emit("remove-file");
        },
        handleChange(file, fileList) {
            this.fileList = fileList.slice(-1);
            this.$emit("files-selected", file.raw);
        },
    }
}
</script>

<template>
    <div>
        <el-upload
            class="upload-file"
            ref="upload"
            action=""
            :http-request="httpRequest"
            :file-list="fileList"
            :before-upload="validFile"
            :on-change="handleChange"
            :on-remove="removeFile"
            :on-success="() => $emit('upload-success')"
            :auto-upload="httpRequest !== undefined"
            accept=".pdf, image/*"
        >
            <div slot="trigger" :class="[fullWidth ? 'w-100' : '', customClass]">
                <slot name="button">
                    <el-button type="primary"
                               class="w-100"
                               v-if="fileList.length === 0"
                    >
                        <slot>Прикріпити файл</slot>
                    </el-button>
                </slot>
            </div>
        </el-upload>
    </div>
</template>

<style scoped>
.file-name {
    text-align: center;
    span {
        font-size: 8px;
        color: #8C8C8C;
        cursor: pointer;
    }
}
.fade-enter-active, .fade-leave-active {
    transition: opacity 1s ease;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
.upload-file {
    width: 100%;
    display: block;
}
* >>> .el-upload--text {
    width: 100%;
}
* >>> .el-upload-list--text {
    text-align: center;
}
* >>> .el-upload {
    display: block;
}
</style>
